module.exports = __webpack_public_path__ + "img/top.283d270f.png";